import { PureComponent } from 'react';
import React  from 'react';
import ProductAttributeValue from 'Component/ProductAttributeValue';
import './ProductSpecs.style.scss';

export default class ProductSpecs extends PureComponent {
    renderAttr(attr, index) {
        if (!attr || !attr.attribute_value) {
            return null;
        }

        return (
           <>
               <tr>
                   <th><strong>{ attr.attribute_label }:</strong></th>
                   <td><ProductAttributeValue attribute={ attr } isFormattedAsText /></td>
               </tr>
           </>
    );
    }

    render() {
        const {
            actiune, varsta, tip_ten, tip_par, use, ingrediente
        } = this.props;

        return (
            <div>
                <div block="ProductSpecs">
                    <table className='product-specs'>
                        { [actiune, varsta, tip_ten, tip_par, use, ingrediente].map((attr, index) => this.renderAttr(attr, index)) }
                    </table>
                </div>
            </div>
    );
    }
}
